import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageSearchPanelComponent } from '../shared/page-layout/page-search-panel.component';

@Component({
  selector: 'app-warehousing-search-panel',
  standalone: true,
  imports: [CommonModule, PageSearchPanelComponent],
  template: `
    <app-page-search-panel
      [title]="title"
      [collapsed]="collapsed"
      [resultText]="resultCount + ' of ' + totalCount + ' records'"
      (clear)="clear.emit()"
      (search)="search.emit()">
      <ng-content></ng-content>
    </app-page-search-panel>
  `,
  styles: [`
    :host {
      display: block;
      margin-bottom: 1rem;
    }
  `]
})
export class WarehousingSearchPanelComponent {
  @Input() title = 'Search';
  @Input() collapsed = true;
  @Input() resultCount = 0;
  @Input() totalCount = 0;
  @Output() search = new EventEmitter<void>();
  @Output() clear = new EventEmitter<void>();
}
